import { Controller } from "@hotwired/stimulus"

// Conecta-se a data-controller="ravi"
export default class extends Controller {
  static targets = ["history", "input", "send", "sidebar", "toggleMobile"]

  connect() {
    console.log("RaviController connected")

    document.body.classList.add("ravi-chat-page")

    this.historyElement = this.hasHistoryTarget
      ? this.historyTarget
      : this.element.querySelector(".ravi-room__chat-history")

    this.inputElement = this.hasInputTarget
      ? this.inputTarget
      : this.element.querySelector("#textarea-message")

    this.sendButton = this.hasSendTarget
      ? this.sendTarget
      : this.element.querySelector(".ravi-room__send")

    this.sidebarElement = this.hasSidebarTarget
      ? this.sidebarTarget
      : this.element.querySelector(".ravi-sidebar")

    this.toggleMobileElement = this.hasToggleMobileTarget
      ? this.toggleMobileTarget
      : this.element.querySelector(".ravi-sidebar__toggle-mobile")

    this.chatName = this.historyElement?.dataset.chatName || "Você"

    this.userAvatar = this.historyElement?.dataset.userAvatar || "/assets/images/ravi/aluno.jpeg"

    if (this.toggleMobileElement && this.sidebarElement) {
      if (this.sidebarElement.classList.contains("collapsed")) {
        this.toggleMobileElement.classList.remove("hidden")
        this.toggleMobileElement.classList.add("flex")
      } else {
        this.toggleMobileElement.classList.add("hidden")
        this.toggleMobileElement.classList.remove("flex")
      }
    }

    this.setupQuickActions()

    this.scrollHistory()
  }

  setupQuickActions() {
    const quickActions = document.querySelectorAll(".quick-action")
    quickActions.forEach(button => {
      button.addEventListener("click", () => {
        const question = button.dataset.question
        if (question && this.inputElement) {
          this.inputElement.value = question
          this.inputElement.focus()
        }
      })
    })
  }

  disconnect() {
    document.body.classList.remove("ravi-chat-page")
  }


  openComoUsar(event) {
    if (event) event.preventDefault()
    const modal = document.getElementById("comoUsarModal")
    if (modal) {
      modal.classList.remove("hidden")
      modal.classList.add("flex")
      document.body.style.overflow = "hidden"
    }
  }

  closeComoUsarModal(event) {
    if (event) event.preventDefault()
    const modal = document.getElementById("comoUsarModal")
    if (modal) {
      modal.classList.add("hidden")
      modal.classList.remove("flex")
      document.body.style.overflow = ""

      const iframe = modal.querySelector("iframe")
      if (iframe) {
        const iframeSrc = iframe.src
        iframe.src = ""
        iframe.src = iframeSrc
      }
    }
  }

  toggleSidebar() {
    if (this.sidebarElement) {
      const isCollapsed = this.sidebarElement.classList.contains("collapsed")
      this.sidebarElement.classList.toggle("collapsed")

      if (this.hasToggleMobileTarget) {
        if (isCollapsed) {
          this.toggleMobileTarget.classList.add("hidden")
        } else {
          this.toggleMobileTarget.classList.remove("hidden")
          this.toggleMobileTarget.classList.add("flex")
        }
      }
    }
  }

  switchToChat(event) {
    event.preventDefault()
    const chatId = event.currentTarget.dataset.chatId
    window.location.href = `/c/${chatId}`
  }

  createNewChat(event) {
    event.preventDefault()
    window.location.href = `/`
  }

  deleteChat(event) {
    event.preventDefault()
    event.stopPropagation() // Prevenir que o click no chat seja acionado

    const chatItem = event.currentTarget.closest("[data-chat-id]")
    const chatId = chatItem?.dataset.chatId

    if (!chatId) return

    if (!confirm("Tem certeza que deseja excluir este chat?")) {
      return
    }

    fetch(`/rav_chats/${chatId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.message && data.message.includes("sucesso")) {
          if (chatItem) {
            chatItem.remove()
          }

          const currentPath = window.location.pathname
          if (currentPath.includes(`/c/${chatId}`)) {
            window.location.href = "/"
          }
        } else {
          alert(data.message || "Erro ao excluir chat")
        }
      })
      .catch(error => {
        console.error("Erro ao deletar chat:", error)
        alert("Não foi possível excluir o chat. Tente novamente.")
      })
  }

  async handleSendMessage(event) {
    if (event) event.preventDefault()

    const message = (this.inputElement?.value || "").trim()

    const name = this.historyElement?.dataset.chatName || "Você"
    if (name == "Usuário") {
      this.renderError("Cadastre-se para usar o assistente IA.")
      return
    }

    if (message.length < 3) {
      this.renderError("Digite uma mensagem com pelo menos 3 caracteres.")
      return
    }

    const existingChatId = this.getChatIdFromUrl() || this.getChatIdFromDataChannel()
    const chatUuid = existingChatId || this.generateUUID()

    this.toggleSendButton(true)

    try {
      const response = await fetch("/home", {
        method: "POST",
        body: JSON.stringify({ question: message, chat_id: chatUuid }),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      })

      const payload = JSON.parse(await response.text())

      if (payload?.message) {
        this.renderError(payload.message)
        return
      }

      this.removeEmptyState()

      if (!existingChatId) {
        window.location.href = `/c/${chatUuid}`
        return
      }

      this.appendUserMessage(message)
      this.renderPendingAssistantMessage()
      this.inputElement.value = ""
      this.scrollHistory()
    } catch (error) {
      console.error(error)
      this.renderError("Não foi possível enviar a mensagem. Tente novamente.")
    } finally {
      this.toggleSendButton(false)
    }
  }

  async handleSendMessageNewUser(event) {
    if (event) event.preventDefault()

    const message = (this.inputElement?.value || "").trim()

    if (message.length < 3) {
      this.renderError("Digite uma mensagem com pelo menos 3 caracteres.")
      return
    }

    const dailyCount = this.getGuestDailyCount()

    if (dailyCount >= 3) {
      this.renderError("Você atingiu o limite de 3 mensagens grátis por dia. Cadastre-se gratuitamente para ter acesso ilimitado!")
      return
    }

    const existingChatId = this.getChatIdFromUrl() || this.getChatIdFromDataChannel()
    const chatUuid = existingChatId || this.generateUUID()

    let threadMessages = null
    if (this.historyElement && this.historyElement.dataset.threadMessages) {
      try {
        threadMessages = this.historyElement.dataset.threadMessages
      } catch (e) {
        console.error("Erro ao parsear thread_messages:", e)
        threadMessages = null
      }
    }

    this.toggleSendButton(true)

    try {
      const newCount = dailyCount + 1
      this.updateGuestDailyCount(newCount)

      const response = await fetch("/home/create_guest", {
        method: "POST",
        body: JSON.stringify({
          question: message,
          chat_id: chatUuid,
          daily_count: dailyCount,
          thread_messages: threadMessages
        }),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      })

      const payload = JSON.parse(await response.text())

      if (payload?.message) {
        this.updateGuestDailyCount(dailyCount)
        this.renderErrorNewUser(payload.message)
        return
      }

      this.removeEmptyState()

      if (!existingChatId && this.historyElement) {
        this.historyElement.dataset.channel = `chat-${chatUuid}`
      }

      this.appendUserMessage(message)
      this.renderPendingAssistantMessage()
      this.inputElement.value = ""
      this.scrollHistory()
    } catch (error) {
      console.error(error)

      this.updateGuestDailyCount(dailyCount)
      this.renderErrorNewUser("Não foi possível enviar a mensagem. Tente novamente.")
    } finally {
      this.toggleSendButton(false)
    }
  }

  getGuestDailyCount() {
    try {
      const today = new Date().toDateString()
      const stored = localStorage.getItem("guest_chat_daily")

      if (!stored) return 0

      const data = JSON.parse(stored)

      if (data.date !== today) {
        return 0
      }

      return data.count || 0
    } catch (error) {
      console.error("Erro ao ler cota diária:", error)
      return 0
    }
  }

  updateGuestDailyCount(count) {
    try {
      const today = new Date().toDateString()
      localStorage.setItem("guest_chat_daily", JSON.stringify({
        date: today,
        count: count
      }))
    } catch (error) {
      console.error("Erro ao atualizar cota diária:", error)
    }
  }

  getChatIdFromUrl() {
    const path = window.location.pathname
    const match = path.match(/\/c\/([^/]+)$/)
    return match ? match[1] : null
  }

  getChatIdFromDataChannel() {
    if (!this.historyElement) return null
    const channel = this.historyElement.dataset.channel
    if (channel && channel.startsWith('chat-') && channel !== 'chat-0') {
      return channel.replace('chat-', '')
    }
    return null
  }

  generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID()
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0
      const v = c == 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }

  updateUrlWithChatId(uuid) {
    const currentPath = window.location.pathname
    const basePath = currentPath.replace(/\/c\/[^/]+$/, '')
    const newPath = `${basePath}/c/${uuid}`

    window.history.pushState({ chatId: uuid }, '', newPath)
  }


  toggleSendButton(disabled) {
    if (this.sendButton) this.sendButton.disabled = disabled
  }

  removeEmptyState() {
    const emptyState = this.historyElement.querySelector(".chat-empty")
    if (emptyState) emptyState.remove()
  }

  appendUserMessage(text) {
    if (!this.historyElement) return

    const bubble = this.buildBubble({
      variant: "user",
      name: this.chatName,
      timestamp: new Date(),
      content: text,
      avatar: this.userAvatar,
      secondary: null,
    })

    this.historyElement.appendChild(bubble)
  }

  renderPendingAssistantMessage() {
    if (!this.historyElement) return

    if (this.pendingBubble) {
      this.pendingBubble.remove()
    }

    const loaderBubble = document.createElement("article")
    loaderBubble.className = "flex flex-col gap-3 max-w-[75%] mr-auto p-4 rounded-2xl bg-slate-800/80 border border-purple-500/20 shadow-lg shadow-purple-900/20"
    loaderBubble.id = "assistant-loader"
    loaderBubble.innerHTML = `
      <div class="flex items-center gap-3">
        <img src="/assets/images/ravi/rav.jpeg" alt="Rav" class="w-10 h-10 rounded-xl object-cover shadow-md">
        <div class="flex flex-col">
          <strong class="text-white font-semibold text-sm">Rav</strong>
          <span class="text-slate-400 text-xs">Carregando...</span>
        </div>
      </div>
      <div class="text-slate-200 text-sm leading-relaxed">
        <div class="inline-flex items-center gap-1.5 py-1">
          <span class="w-2 h-2 rounded-full bg-purple-400 animate-bounce" style="animation-delay: 0s"></span>
          <span class="w-2 h-2 rounded-full bg-purple-400 animate-bounce" style="animation-delay: 0.15s"></span>
          <span class="w-2 h-2 rounded-full bg-purple-400 animate-bounce" style="animation-delay: 0.3s"></span>
        </div>
      </div>
    `

    this.historyElement.appendChild(loaderBubble)
    this.pendingBubble = loaderBubble
    this.scrollHistory()
  }

  appendAssistantMessage(text) {
    if (!this.historyElement) return

    if (this.pendingBubble) {
      this.pendingBubble.remove()
      this.pendingBubble = null
    }

    const bubble = this.buildBubble({
      variant: "assistant",
      name: "Rav",
      timestamp: new Date(),
      content: text,
      avatar: "/assets/images/ravi/rav.jpeg",
      secondary: "/assets/images/ravi/ravi-title.png",
    })

    this.historyElement.appendChild(bubble)
    this.scrollHistory()
  }

  buildBubble({ variant, name, timestamp, content, avatar, secondary }) {
    const bubble = document.createElement("article")
    const isUser = variant === "user"
    bubble.className = `flex flex-col gap-3 max-w-[75%] p-4 rounded-2xl shadow-xl animate-slide-up transition-all duration-200 ${isUser
      ? "ml-auto bg-gradient-to-br from-purple-600 via-purple-700 to-purple-800 shadow-purple-500/40 hover:shadow-purple-500/50"
      : "mr-auto bg-gradient-to-br from-slate-800/90 to-slate-900/90 border border-purple-500/30 shadow-purple-900/30 hover:shadow-purple-900/40 hover:border-purple-500/40"
      }`

    const author = document.createElement("div")
    author.className = "flex items-center gap-3"

    const avatarContainer = document.createElement("div")
    avatarContainer.className = "relative"

    const avatarImg = document.createElement("img")
    avatarImg.src = avatar
    avatarImg.alt = name
    avatarImg.className = `w-10 h-10 rounded-xl object-cover shadow-lg ring-2 ${isUser ? "ring-purple-400/30" : "ring-purple-500/30"}`

    if (!isUser) {
      const statusBadge = document.createElement("div")
      statusBadge.className = "absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-slate-800 flex items-center justify-center"
      statusBadge.innerHTML = '<i class="fa-solid fa-check text-[8px] text-white"></i>'
      avatarContainer.appendChild(statusBadge)
    }

    avatarContainer.appendChild(avatarImg)

    const meta = document.createElement("div")
    meta.className = "flex flex-col"

    const nameContainer = document.createElement("div")
    nameContainer.className = "flex items-center gap-2"

    const strong = document.createElement("strong")
    strong.textContent = isUser ? name : "Rav IA"
    strong.className = "font-semibold text-sm text-white"

    const badge = document.createElement("span")
    if (isUser) {
      badge.className = "px-2 py-0.5 bg-white/20 rounded-full text-[10px] text-white font-medium"
      badge.textContent = "Você"
    } else {
      badge.className = "px-2 py-0.5 bg-gradient-to-r from-purple-600/30 to-purple-800/30 border border-purple-500/30 rounded-full text-[10px] text-purple-200 font-medium flex items-center gap-1"
      badge.innerHTML = '<i class="fa-solid fa-sparkles text-[8px]"></i> IA'
    }

    nameContainer.appendChild(strong)
    nameContainer.appendChild(badge)

    const time = document.createElement("span")
    time.textContent = this.formatTimestamp(timestamp)
    time.className = `text-xs ${isUser ? "text-purple-200" : "text-slate-400"}`

    meta.appendChild(nameContainer)
    meta.appendChild(time)

    author.appendChild(avatarContainer)
    author.appendChild(meta)

    const body = document.createElement("div")
    body.className = `text-sm leading-relaxed ${isUser ? "text-white/95" : "text-slate-200"}`
    body.appendChild(this.formattedText(content))

    bubble.appendChild(author)
    bubble.appendChild(body)

    return bubble
  }

  formattedText(text) {
    const container = document.createElement("div")
    const lines = text.split("\n")

    lines.forEach((line, index) => {
      const lineDiv = document.createElement("div")

      line
        .split(/(\*\*[^*]+\*\*)/)
        .filter(Boolean)
        .forEach((segment) => {
          if (segment.startsWith("**") && segment.endsWith("**")) {
            const bold = document.createElement("b")
            bold.textContent = segment.slice(2, -2)
            lineDiv.appendChild(bold)
          } else {
            const span = document.createElement("span")
            span.textContent = segment
            lineDiv.appendChild(span)
          }
        })

      container.appendChild(lineDiv)

      if (index < lines.length - 1) {
        container.appendChild(document.createElement("br"))
      }
    })

    return container
  }

  formatTimestamp(value) {
    if (!value) return "agora"

    const date = value instanceof Date ? value : new Date(value)
    const day = date.getDate()
    const monthFormatter = new Intl.DateTimeFormat("pt-BR", {
      month: "long"
    })
    const month = monthFormatter.format(date)
    const monthCapitalized = month.charAt(0).toUpperCase() + month.slice(1)

    const timeFormatter = new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    })
    const time = timeFormatter.format(date)

    return `${day} de ${monthCapitalized}, ${time}`
  }

  openInformationModal(event) {
    event.preventDefault()
    const modal = document.getElementById("informationChat")
    if (modal) {
      modal.classList.remove("hidden")
      modal.classList.add("flex")
      document.body.style.overflow = "hidden"
    }
  }

  closeInformationModal(event) {
    if (event) event.preventDefault()
    const modal = document.getElementById("informationChat")
    if (modal) {
      modal.classList.add("hidden")
      modal.classList.remove("flex")
      document.body.style.overflow = ""
    }
  }

  openPrecos(event) {
    event.preventDefault()
    window.open(
      "https://ranipassos.com.br/courses/assinatura-rav-i-inteligencia-artificial/nqiBWAek/DJEgOJbv",
      "_blank"
    )
  }

  openReportErrorModal(event) {
    event.preventDefault()
    const modal = document.getElementById("reportarErro")
    if (modal) {
      modal.classList.remove("hidden")
      modal.classList.add("flex")
      document.body.style.overflow = "hidden"
    }
  }

  closeReportErrorModal(event) {
    if (event) event.preventDefault()
    const modal = document.getElementById("reportarErro")
    if (modal) {
      modal.classList.add("hidden")
      modal.classList.remove("flex")
      document.body.style.overflow = ""
    }
  }

  reportError(event) {
    event.preventDefault()

    const form = event.currentTarget
    const formData = new FormData(form)

    const title = formData.get('title')
    const content = formData.get('content')

    if (!title || !content) {
      this.renderError("Por favor, preencha todos os campos.")
      return
    }

    fetch("/home/report_error", {
      method: "POST",
      body: JSON.stringify({
        title: title,
        content: content
      }),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.message) {
          if (data.message.includes("sucesso")) {
            Swal.fire("Erro reportado com sucesso!", "Obrigado pela sua contribuição.", "success")
            form.reset()
            this.closeReportErrorModal()
          } else {
            this.renderError(data.message)
          }
        }
      })
      .catch(error => {
        console.error("Erro ao reportar:", error)
        this.renderError("Não foi possível enviar o relatório. Tente novamente.")
      })
  }

  scrollHistory() {
    if (!this.historyElement) return
    requestAnimationFrame(() => {
      this.historyElement.scrollTop = this.historyElement.scrollHeight
    })
  }

  renderError(message) {
    Swal.fire({
      title: "Ops!",
      text: message,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Saiba mais",
      cancelButtonText: "OK",
      confirmButtonColor: "#9333ea",
      cancelButtonColor: "#64748b",
      reverseButtons: true,
      customClass: {
        popup: "rounded-2xl",
        confirmButton: "bg-purple-600 hover:bg-purple-700",
        cancelButton: "bg-slate-600 hover:bg-slate-700"
      }
    }).then((result) => {
      if (result.isConfirmed) {
        window.open(
          "https://ranipassos.com.br/courses/assinatura-rav-i-inteligencia-artificial/nqiBWAek/DJEgOJbv",
          "_blank"
        )
      }
    })

    this.toggleSendButton(false)
  }

  renderErrorNewUser(message) {
    Swal.fire({
      title: "Ops!",
      text: message,
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Saiba mais",
      denyButtonText: "Cadastre-se",
      confirmButtonColor: "#9333ea",
      denyButtonColor: "#16a34a",
      reverseButtons: true,
      customClass: {
        popup: "rounded-2xl",
        confirmButton: "bg-purple-600 hover:bg-purple-700",
        denyButton: "bg-green-600 hover:bg-green-700"
      }
    }).then((result) => {
      if (result.isConfirmed) {
        window.open(
          "https://ranipassos.com.br/courses/assinatura-rav-i-inteligencia-artificial/nqiBWAek/DJEgOJbv",
          "_blank"
        )
      } else if (result.isDenied) {
        window.location.href = "/login/new"
      }
    })

    this.toggleSendButton(false)
  }
}